import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';

const TermsPage: React.FC = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Alert1.com Website Terms and Conditions</h1>
        
        <h2>Alert1 Medical Alert's Website Terms and Conditions</h2>

        <p>
          Your access to and use of this site is subject to the following terms and conditions and all applicable laws. By accessing 
          and using this site, you accept the following terms and conditions, without limitation or qualification.
        </p>

        <h2>Intellectual Property</h2>
        
        <p>
          Unless otherwise stated, the contents of this site including, but not limited to, the text and images contained herein and 
          their arrangement are the property of Alert1. All trademarks used or referred to in this website are the property of their 
          respective owners.
        </p>

        <p>
          Nothing contained in this site shall be construed as conferring by implication, estoppel, or otherwise, any license or right 
          to any copyright, patent, trademark or other proprietary interest of Alert1 or any third party.
        </p>

        <h2>Permitted Use</h2>
        
        <p>
          This site and the content provided in this site, including, but not limited to, graphic images, audio, video, html code, 
          buttons, and text, may not be copied, reproduced, republished, uploaded, posted, transmitted, or distributed in any way, 
          without the prior written consent of Alert1, except that you may download, display, and print one copy of the materials on 
          any single computer solely for your personal, non-commercial use, provided that you do not modify the material in any way and 
          you keep intact all copyright, trademark, and other proprietary notices.
        </p>

        <h2>Information and Services</h2>
        
        <p>
          The information provided on this site is free of charge and for informational purposes only and does not create a business or 
          professional services relationship between you and Alert1 other than what is explicitly outlined under Service Contract Terms 
          and Conditions upon the purchase of a Medical Emergency Monitoring Subscription Service.
        </p>

        <p>
          Links on this site may lead to services or sites not operated by Alert1. No judgment or warranty is made with respect to such 
          other services or sites and Alert1 takes no responsibility for such other sites or services. A link to another site or service 
          is not an endorsement of that site or service. Any use you make of the information provided on this site, or any site or 
          service linked to by this site, is at your own risk.
        </p>

        <h2>Disclaimer of Warranties</h2>
        
        <p>
          This site and its contents are provided "as is" and Alert1 makes no representation or warranty of any kind with respect to 
          this site or any site or service accessible through this site. Alert1 expressly disclaims all express and implied warranties 
          including, but not limited to, the implied warranties of merchantability, fitness for a particular purpose, title, and 
          non-infringement.
        </p>

        <h2>Limitation of Liability</h2>
        
        <p>
          In no event will Alert1 be liable to any party for any direct, indirect, incidental, special, exemplary, consequential, or 
          other damages (including, but not limited to, lost profits, business interruption, loss of programs or data) without regard 
          to the form of action and whether in contract, tort, negligence, strict liability, or otherwise, arising out of or in 
          connection with this site, any content on or accessed through this site or any site service linked to, or any copying, 
          displaying, or use thereof.
        </p>

        <h2>Governing Law and Jurisdiction</h2>
        
        <p>
          You agree that these terms of use and any legal action or proceeding relating to this site shall be governed by the laws of 
          the Commonwealth of Pennsylvania without reference to its choice of law rules. If you attempt to bring any legal proceedings 
          against Alert1 you specifically acknowledge that Alert1 is free to choose the jurisdiction of our preference as to where such 
          action against us may be held. As you have agreed by using this site to choose the laws of the Commonwealth of Pennsylvania 
          to govern any such proceedings, we will probably choose to defend any such action in Illinois and we can make this decision 
          entirely as it suits us, without regard to where in the world you are located, or from where in the world you visited this site.
        </p>

        <h2>User Compliance</h2>
        
        <p>
          You are responsible for complying with the laws of the jurisdiction from which you are accessing this site and you agree that 
          you will not access or use the information on this site in violation of such laws. Unless expressly stated otherwise herein, 
          any information submitted by you through this site shall be deemed non-confidential and non-proprietary. You represent that 
          you have the lawful right to submit such information and agree that you will not submit any information unless you are legally 
          entitled to do so.
        </p>

        <p>
          Because of the open nature of the Internet, we recommend that you not submit information you consider confidential.
        </p>

        <h2>Idea Submissions</h2>
        
        <p>
          Alert1 does not accept unauthorized idea submissions outside of established business relationships. To protect the interests 
          of our current clients and ourselves, we must treat the issue of such submissions with great care. Importantly, without a 
          clear business relationship, Alert1 cannot and does not treat any such submissions in confidence.
        </p>

        <p>
          Accordingly, please do not communicate unauthorized idea submissions to Alert1 through this website. Any ideas disclosed to 
          Alert1 outside a pre-existing and documented confidential business relationship are not confidential and Alert1 may therefore 
          develop, use and freely disclose or publish similar ideas without compensating you or accounting to you.
        </p>

        <p>
          Alert1 will make every reasonable effort to return or destroy any unauthorized idea submissions without detailed review of 
          them. However, if a review is necessary in Alert1's sole discretion, it will be with the understanding that Alert1 assumes 
          no obligation to protect the confidentiality of your idea or compensate you for its disclosure or use. By submitting an idea 
          or other detailed submission to Alert1 through this website, you agree to be bound by the terms of this stated policy.
        </p>

        <p className="legal-last-updated">
          Last Updated: October 2025
        </p>

        <div className="legal-footer-links">
          <Link to="/">Return to Home</Link>
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TermsPage;

